import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProveedoresService {
  TOKEN = localStorage.getItem('token');

  constructor(private http: HttpClient) { }

  getProveedores(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getProveedores/");
  }

  getProveedoresFiltrados(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getProveedoresFiltrados/", data);
  }

  agregarProveedor(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarProveedor/", data);
  }

  editarProveedor(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarProveedor/", data);
  }

  updateProveedor(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateProveedor/", data);
  }


  getEstados(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getEstados/");
  }

  getMunicipios(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getMunicipios/", data);
  }

 
}
